import moment from "moment";
import React from "react";

const RelatorioEncaminhamentosImpressao = ({
  filters,
  dadosRelatorio,
  totalElements,
}) => {
  const { dataInicio, dataFim, profissionalSaude, encaminhamento } = filters || {};

  return (
    <>
      <div style={styles.titulo}>Relatório de encaminhamentos</div>
      <div style={styles.subTitulo}>
        {profissionalSaude && (
          <div>
            Profissional:
            <span>{profissionalSaude.nome} </span>
          </div>
        )}
        {dataInicio && (
          <div>
            Data inicio:
            <span> {moment(dataInicio).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {dataFim && (
          <div>
            Data Fim:
            <span> {moment(dataFim).format("DD/MM/YYYY")}</span>
          </div>
        )}
        {encaminhamento?.id && (
          <div>
            Encaminhamento:
            <span>{encaminhamento.nome} </span>
          </div>
        )}
      </div>
      <div style={styles.headerColumn}>
        <div style={styles.column}>Profissional</div>
        <div style={styles.column}>Paciente</div>
        <div style={styles.column}>Data Emissao</div>
        <div style={styles.column}>Encaminhamento</div>
      </div>
      <div>
        {dadosRelatorio.map((item, index) => {
          return (
            <div key={item.id} style={styles.containerColuna}>
              <div style={styles.column}>{item?.profissionalSaude?.nome}</div>
              <div style={styles.column}>{item.sujeitoAtencao.nome}</div>
              <div style={styles.column}>
                {moment(item.dataHoraEmissao).format("DD/MM/YYYY")}
              </div>
              <div style={styles.column}>
                {item.encaminhamentoEntidade.nome}
              </div>
            </div>
          );
        })}
      </div>
      <div style={styles.footer}>
        <span style={styles.span}>Total {totalElements}</span>
      </div>
    </>
  );
};

const styles = {
  titulo: {
    marginLeft: "0px",
    marginBottom: "10px",
    marginTop: "5px",
    paddingBottom: "5px",
    textAlign: "center",
    fontWeight: 700,
  },
  subTitulo: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #505050",
    marginBottom: "15px",
    paddingBottom: "5px",
    fontWeight: 700,
    justifyContent: "center",
    gap: "8px",
  },

  headerColumn: {
    display: "flex",
    flexDirection: "row",
    fontWeight: 700,
    width: "100%",
  },
  containerColuna: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  columnProcedimento: {
    width: "70%",
  },
  column: {
    width: "30%",
  },
  footer: {
    marginLeft: "10px",
    marginTop: "10px",
    textAlign: "center",
    fontWeight: 700,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "end",
  },
  span: {
    padding: "10px",
  },
};

export default RelatorioEncaminhamentosImpressao;
